import React, { useEffect, useState } from "react";
import { ChevronDown, Loader2, UserX } from "lucide-react";
import { api } from "@/lib/api";

export function IncompleteProfiles({ onOpen }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/profiles/incomplete").then(({ data }) => setData(data)).catch(() => setData({ students: [], incomplete: 0, total: 0 })); }, []);
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-3" data-testid="incomplete-profiles">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-sm font-semibold text-amber-900" data-testid="incomplete-profiles-toggle">
        <span className="flex items-center gap-2"><UserX className="h-4 w-4" />
          {data ? `${data.incomplete} of ${data.total} student profiles not 100% complete` : "Checking profiles…"}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (!data ? <Loader2 className="h-5 w-5 animate-spin mt-3" /> : (
        <div className="mt-3 space-y-2 max-h-[420px] overflow-y-auto" data-testid="incomplete-profiles-list">
          {data.students.length === 0 ? <p className="text-xs text-green-700">All profiles are complete.</p> : data.students.map((s) => (
            <button key={s.id} type="button" onClick={() => onOpen && onOpen(s)} data-testid={`incomplete-${s.id}`}
              className="w-full text-left rounded-xl bg-white border border-amber-100 p-3 hover:bg-amber-100/40 transition-colors">
              <div className="flex items-center justify-between gap-2">
                <p className="font-semibold text-slate-900 truncate">{s.name} <span className="text-xs font-normal text-slate-500">· {s.student_class} · Roll {s.roll_number || "—"}</span></p>
                <span className="text-xs font-bold text-amber-700 shrink-0">{s.completion}%</span>
              </div>
              <p className="text-xs text-red-700 mt-1">Missing: {s.missing.join(", ")}</p>
              {s.teachers.length > 0 && <p className="text-xs text-slate-500">Teacher: {s.teachers.join(", ")}</p>}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
